/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/PaymentCompletedDialog/theme';

export const PaymentCompletedDialogTheme = theme;
